module.exports = __webpack_public_path__ + "media/images/elionline/logo-white-f3faf92c84e4ed93c087d1efadae83c5.png";